const FAILURE_CODE = -1;
const SUCCESS_CODE =  1;
const REVOKED_CODE =  2;

export const RULE_STATUS = {
  "FAILED"    : -1,
  "PASSED"    :  1,
  "OVERRULED" :  2,
}

export {
  FAILURE_CODE, SUCCESS_CODE, REVOKED_CODE,
}